export * from "./user";
export * from "./meeting";
export * from "./activity";

export type T_Integration =
  | "drive"
  | "gmail"
  | "calendar"
  | "slack"
  | "contacts"
  | "zoom"
  | "xembly"
  | "readAI"
  | "github"
  | "figma";

export type T_StorageKey =
  | "refreshToken"
  | "accessToken"
  | "isIntegrationDone"
  | "userOnboarded"
  | "isCallBooked";

export enum EActivityEvent {
  Login = "login",
  Logout = "logout",
  PodcastClicked = "podcast-clicked",
  PodcastPlayed = "podcast-played",
  PodcastPageViewed = "podcast-page-viewed",
  HomePageViewed = "home-page-viewed",
  SettingsPageViewed = "settings-page-viewed",
  CalendarPageViewed = "calendar-page-viewed",
  ActivityPageViewed = "activity-page-viewed",
  MeetingSummaryPageViewed = "meeting-summary-page-viewed",
  TodoPageViewed = "todo-page-viewed",
  BillingPageViewed = "billing-page-viewed",
  AssistantSetupPageViewed = "assistant-setup-page-viewed",
  PocastSpeedChanged = "podcast-speed-changed",
  MeetingPrepClicked = "meeting-prep-clicked",
  TranscriptOpened = "transcript-opened",
  PushNotificationClicked = "push-notification-clicked",
  CampainEmailClicked = "campain-email-clicked",
  CampainEmailOpened = "campain-email-opened",
  DemoModeActivated = "demo-mode-activated",
  AccountDeleted = "account-deleted",
  AccountDeactivated = "account-deactivated",
  ManageCreditClicked = "manage-credit-card-clicked",
  GmailConnected = "gmail-connected",
  CalendarConnected = "calendar-connected",
  SettingsButtonClicked = "settings-button-clicked",
  CalendarFilterClicked = "calendar-filter-clicked",
  ActivityLogClicked = "activity-log-clicked",
  PrivacyPolicyClicked = "privacy-policy-clicked",
  ActivityLogViewed = "activity-log-viewed",
  TodoClicked = "todo-clicked",
  General = "general",
}

export type T_Activity = {
  user: string;
  event: EActivityEvent;
  source: string;
  data?: any;
  date?: Date;
};
